module.exports = __webpack_public_path__ + "img/nexultra-1.7f213c10.jpg";